var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33464 10.0001L9.33463 13.3334L14.668 6.66675M10.0013 19.3334C8.77563 19.3334 7.56196 19.092 6.42959 18.623C5.29722 18.1539 4.26832 17.4664 3.40164 16.5997C2.53496 15.7331 1.84747 14.7042 1.37843 13.5718C0.909383 12.4394 0.667969 11.2258 0.667969 10.0001C0.667969 8.77441 0.909383 7.56074 1.37843 6.42837C1.84747 5.296 2.53496 4.2671 3.40164 3.40042C4.26832 2.53374 5.29722 1.84625 6.42959 1.37721C7.56196 0.908162 8.77563 0.666748 10.0013 0.666748C12.4767 0.666748 14.8506 1.65008 16.601 3.40042C18.3513 5.15076 19.3346 7.52473 19.3346 10.0001C19.3346 12.4754 18.3513 14.8494 16.601 16.5997C14.8506 18.3501 12.4767 19.3334 10.0013 19.3334Z",
    stroke: "black",
    strokeOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleIcon);
export default __webpack_public_path__ + "static/media/tickCircleIcon.f530eaaeeae470aa4ed4df74b50d4b55.svg";
export { ForwardRef as ReactComponent };